import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../styles/Notifications.scss';
import { faComment, faSearch, faXmarkCircle } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'react-bootstrap';
import UniInput, { FormControlElement } from '../components/UniInput/UniInput';
import UniPagination from '../components/UniPagination/UniPagination';
import { ChangeEvent, useEffect, useState } from 'react';
import { useUserStore } from '../store/user';
import { useNavigate } from 'react-router-dom';
import UniModal from '../components/UniModal/UniModal';
import { useTranslation } from 'react-i18next';
import UniTable, { DataTable } from '../components/UniTable/UniTable';
import { Notice, getNotices } from '../services/noticeService';
import { CustomerGroup } from '../types/enumsNotice';
import { getEnumCountry, getEnumCustomerGroup } from '../helpers/enums';

type SearchForm = {
    search?: string,
    initialDate?: string,
    finishDate?: string,
    country?: string, 
    purchaseGroup?: Number
};

const Notifications = () => {
    const [notifications, setNotifications] = useState<Notice[]>([]);
    const [search, setSearch] = useState<SearchForm>();
    const [error, setError] = useState<string>(``);
    const [loading, setLoading] = useState<boolean>(false);
    const [totalPages, setTotalPages] = useState<number>();
    const [totalItems, setTotalItems] = useState<number>();
    const [take, setTake] = useState<any>(10);
    const [page, setPage] = useState<number>(1);
    const { loginData, darkMode } = useUserStore();
    const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        if (localStorage.getItem('tkn')) {
            getNotification();
        }
    }, [loginData.id, take, page]);

    const dataTable: DataTable[] = [
        {
            property: 'id',
            name: `id`,
            notShow: true,
        },
        {
            property: 'titlePt',
            name: t('notification.labelTitlePT'),
            isName: true
        },
        {
            property: 'titleEn',
            name: t('notification.labelTitleEN'),
            isName: true
        },
        {
            property: 'titleEs',
            name: t('notification.labelTitleES'),
            isName: true
        },
        {
            property: 'initialDate',
            name: t('notification.labelInitialDate'),
            isDate: true,
        },
        {
            property: 'finalDate',
            name: t('notification.labelFinalDate'),
            isDate: true
        },
        {
            property: 'purchaseGroup',
            name: t('notification.labelGroup'),
            isEnum: true,
            enumFunc: getEnumCustomerGroup
        },
        {
            property: 'country',
            name: t('notification.labelContry'),
            isEnum: true,
            enumFunc: getEnumCountry
        },
        {
            property: 'actions',
            name: t('notification.labelActions'),
            isAction: true,
        }
    ];

    const getNotification = () => {
        setLoading(true);
        setError('');

        getNotices(take, 
            page, 
            search?.search ?? '', 
            search?.country === '0' ? '' : search?.country ?? '' , 
            search?.initialDate ?? '', 
            search?.finishDate ?? '', 
            search?.purchaseGroup === 0 ? undefined : search?.purchaseGroup ?? undefined)
        .then(response => {
            if (!response.success) {
                setError(response.error ?? '');
                setNotifications([]);
            }
            else {
                setNotifications(response.data);
                setTotalItems(response.totalItems);
                setTotalPages(response.totalPages);
            }
        })
        .catch(e => console.log(e))
        .finally(() => setLoading(false))
    }

    const onChangeSearch = (e: ChangeEvent<FormControlElement> | ChangeEvent<HTMLSelectElement>, typeValue = `search`) => {
        console.log(e?.target?.value, typeValue)
        switch (typeValue) {
            case `search`:
                setSearch({ ...search, search: e?.target?.value });
                break;
            case `country`:
                setSearch({ ...search, country: e?.target?.value });
                break;  
            case `initialDate`:
                setSearch({ ...search, initialDate: e?.target?.value });
                break;
            case `finishDate`:
                setSearch({ ...search, finishDate: e?.target?.value });
                break;
            case `group`:
                setSearch({ ...search, purchaseGroup: Number(e?.target?.value) });
                break;
            default:
                setSearch({ ...search, search: e?.target?.value });
        }
    }

    const goToManage = (id?: string) => {
        if (id) {
            navigate(`manage-notification/${id}`);
            return;
        }

        navigate('manage-notification');
    }

    return (
        <>
            <div className='notification-wrapper'>
                <div className='notification-header w-100'>
                    <div className='notification-header-i'>
                        <FontAwesomeIcon icon={faComment} color='#00FF3C' size='xl' />
                        <p className='w-100'>Informativos</p>
                    </div>
                    <Button variant='primary' onClick={() => goToManage()}>
                        <FontAwesomeIcon style={{ paddingRight: '5px' }} icon={faComment} color='#00FF3C' size='xl' />
                        {t('notification.newNotification')}
                    </Button>
                </div>
                <div className='notification-search w-100'>
                    <div>
                        <UniInput
                            id='search'
                            placeholder={t('notification.searchFields')}
                            label='Busca'
                            type='text'
                            onChangeInput={(e) => onChangeSearch(e)}
                        />
                    </div>
                    <div>
                        <UniInput
                            id='group'
                            placeholder={t('notification.labelGroup')}
                            label={t('notification.labelGroup')}
                            isSelect
                            onChange={(e) => onChangeSearch(e, 'group')}
                        >
                            <option value={`0`} selected>Selecione</option>
                            <option value={'1'}>TODOS</option>
                            <option value={'2'}>PVC</option>
                            <option value={'3'}>QUIMICOS</option>
                        </UniInput>
                    </div>
                    <div>
                        <UniInput
                            id='group-c'
                            placeholder={t('notification.labelContry')}
                            label={t('notification.labelContry')}
                            isSelect
                            onChange={(e) => onChangeSearch(e, 'country')}
                        >
                            <option value={`0`} selected>Selecione</option>
                            <option value={'ALL'}>TODOS</option>
                            <option value={'AR'}>ARGENTINA</option>
                            <option value={'BR'}>BRASIL</option>
                        </UniInput>
                    </div>

                    <FontAwesomeIcon icon={faSearch} title={t('customerScreen.search')} onClick={() => getNotification()} />
                </div>
                <div className='w-100 d-flex justify-content-center'>
                    <UniTable 
                        data={notifications}
                        dataTable={dataTable}
                        darkMode={darkMode}
                        loading={loading}
                        error={error}
                        actionsEdit
                        actionEdit={(id: string) => {goToManage(id)}}
                    />
                </div>
                {
                    <UniPagination totalItems={totalItems} totalPages={totalPages} changePage={(e) => setPage(e)} changeTake={(e) => { setPage(1); setTake(e) }} />
                }
            </div>

            <UniModal
                icon={faXmarkCircle}
                message=''
                iconColor='#EA2027'
                title={error}
                onHide={() => {setError('')}}
                show={error !== ''}
                isFontAwsome
            />
        </>
    );
}

export default Notifications;